import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PurchaseOrderSummaryModel} from '../purchaseOrderSummary.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {DocumentSummaryConverter} from '../../../../../../document/common/api/converter/DocumentSummary.converter';
import {Injectable} from '@angular/core';
import {AccountSummaryConverter} from '../../../../../../account/common/api.converter/AccountSummary.converter';
import {DateConverter} from '../../../../../../common/converter/date.converter';
import {EntityWithAuditMetadataConverter} from '../../../../../../common/converter/entityWithAuditMetadata.converter';

@Injectable({providedIn: 'root'})
export class PurchaseOrderSummaryConverter extends HttpModelConverter<PurchaseOrderSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private dateConverter: DateConverter,
                private documentSummaryConverter: DocumentSummaryConverter,
                private accountSummaryConverter: AccountSummaryConverter,
                private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter) {
        super();
    }

    protected createInstance(): PurchaseOrderSummaryModel {
        return new PurchaseOrderSummaryModel();
    }

    protected enrichObject(result: PurchaseOrderSummaryModel, src: PurchaseOrderSummaryModel) {
        result.document = this.documentSummaryConverter.convert(src.document);
        result.status = this.lovValueSummaryConverter.convert(src.status);
        result.account = this.accountSummaryConverter.convert(src.account);
        result.date = this.dateConverter.convert(src.date);
        result.validUntil = this.dateConverter.convert(src.validUntil);
        this.entityWithAuditMetadataConverter.convert(result, src);
    }
}
